import type { ColumnDefinition } from "@frui.ts/dataviews/dist/dataTypes";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import type AccountBalanceCheckRequestResponse from "entities/accountBalanceCheckRequestResponse";
import { observer } from "mobx-react-lite";
import BalanceViewModel from "viewModels/finance/accountingInventory/balance/balanceViewModel";
import ListView from "../../../common/list";
import BalanceFilters from "./components/balanceFilters";
import BalanceMenu from "./components/balanceMenu";
import { formatDateTime } from "utils/localizations";

export const BalanceView: ViewComponent<BalanceViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<AccountBalanceCheckRequestResponse>[] = [
    {
      title: vm.translateAttribute("accountingPeriodTo"),
      property: "accountingPeriodTo",
      valueFormatter: props => {
        const [year, month] = props.value.split("-");
        return `${month}/${year}`;
      },
    },
    {
      title: vm.translateAttribute("status"),
      property: "status",
      valueFormatter: props => {
        const textClass = vm.getStatusTextClass(props.value);
        const style = textClass === "text-dark-blue" ? { color: "#052856" } : {};

        return (
          <span className={`${textClass === "text-dark-blue" ? "" : textClass} font-weight-bold`} style={style}>
            {vm.translateStatus(props.value)}
          </span>
        );
      },
    },
    {
      title: vm.translateAttribute("createdAt"),
      property: "createdAt",
      cellClassName: "text-left",
      headerClassName: "text-left",
      valueFormatter: props => formatDateTime(new Date(props.value)),
    },
    {
      title: vm.translateAttribute("createdBy"),
      property: "createdBy",
    },
    {
      cellClassName: "text-align-end",
      headerClassName: "py-4 text-wrap align-middle",
      valueFormatter: props => <BalanceMenu vm={vm} checkRequest={props.item} />,
    },
  ];

  return (
    <div className="test">
      <ListView
        vm={vm}
        columns={columns}
        disabledAddButton={!vm.permittedActions?.checkRequestCreation?.isAllowed}
        disabledAddButtonTooltip={vm.translate("disabledAddButtonTooltip")}
        aboveTable={<BalanceFilters vm={vm} />}
      />
    </div>
  );
});

registerView(BalanceView, BalanceViewModel);
